module.exports = __webpack_public_path__ + "img/avatar_karyawan.35cbf5e7.png";